import { isAndroid, isSafari } from "./Misc";

export default class SndMgr {
    audioSrc: any;

    deviceType: any;

    $app: any;

    audio: any;

    audioSupport: any;

    lazyLoaded: boolean;

    /**
     *
     * @param {CIApp} app
     */
    constructor(app, audioSrc) {
        this.audioSrc = audioSrc;
        this.deviceType = app.getSDKInstance().getDeviceType();
        this.setup(app);
        this.$app = app;
    }

    setup(app) {
        if (this.audioSrc) {
            this.audioSrc = app.getSDKInstance().getImagePath() + this.audioSrc;

            if (this.doesDeviceRequireUserPermissions()) {
                this.initMobileAudio();
            }
        }
    }

    initHTMLAudio() {
        this.audio = new Audio(this.audioSrc);
        this.audioSupport = !!this.audio.play;
        this.lazyLoaded = true;
    }

    /*
     *initIEAudio() {
     *
     *}
     */

    initMobileAudio() {
        this.audioSupport = document.createElement("audio");
        const audio = new Audio();
        audio.loop = false;
        const _doc = document;
        const iosSnd: any = {};
        iosSnd.audio = audio;
        iosSnd.audioSource = this.audioSrc;

        /**
         * immediately clear all listeners to initiate mobile audio
         * @param e
         */
        iosSnd.startAudio = function (e) {
            let userAction = false;

            if (e && e.type == "touchstart") {
                userAction = true;
                _doc.removeEventListener("touchstart", iosSnd.startAudio, false);
                _doc.removeEventListener("keydown", iosSnd.startAudio, false);
            } else if (e && e.type == "keydown") {
                userAction = true;
                _doc.removeEventListener("keydown", iosSnd.startAudio, false);
                _doc.removeEventListener("touchstart", iosSnd.startAudio, false);
            } else if (e && e.type == "touchend") {
                userAction = true;
                _doc.removeEventListener("touchend", iosSnd.startAudio, false);
                _doc.removeEventListener("keydown", iosSnd.startAudio, false);
            }

            if (!userAction) {
                iosSnd.audio.src = iosSnd.audioSource;
            }

            iosSnd.audio.play();
        };

        _doc.addEventListener("touchend", iosSnd.startAudio, false);
        _doc.addEventListener("keydown", iosSnd.startAudio, false);

        this.audio = iosSnd;
    }

    playSound() {
        if (this.$app.isSoundEnabled()) {
            if (this.doesDeviceRequireUserPermissions() && this.audioSupport) {
                this.audio.startAudio();
            } else {
                if (!this.lazyLoaded && this.audioSrc) {
                    this.initHTMLAudio();
                }

                if (this.audioSupport) {
                    this.audio.play();
                }
            }
        }
    }

    doesDeviceRequireUserPermissions() {
        return this.deviceType == "Tablet" || this.deviceType == "Phone" || isSafari();
    }
}
